import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import { useSelectorApp } from "../lib/redux";
import { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED } from "../utils/constants";

const useSlideMenuCollapsed = () => {
  const theme = useTheme();
  const slideMenuIsCollapsed = useSelectorApp(
    (state) => state.ui.slideMenuIsCollapsed
  );
  const isTablet = useMediaQuery((muiTheme) => muiTheme.breakpoints.down("md"));
  // Desktop only; the arrow button toggles it and localStorage keeps the choice.
  const isCollapsed = !isTablet && slideMenuIsCollapsed;
  const drawerWidth = isCollapsed ? DRAWER_WIDTH_COLLAPSED : DRAWER_WIDTH;
  const widthTransition = (property) =>
    theme.transitions.create(property, {
      easing: theme.transitions.easing.sharp,
      duration: isCollapsed
        ? theme.transitions.duration.leavingScreen
        : theme.transitions.duration.enteringScreen,
    });

  return { isCollapsed, drawerWidth, widthTransition };
};

export default useSlideMenuCollapsed;
